export const UploadImageIcon = ({ className = '' }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.11111 13C3.80556 13 3.54407 12.8913 3.32667 12.6739C3.10926 12.4565 3.00037 12.1948 3 11.8889V4.11111C3 3.80556 3.10889 3.54407 3.32667 3.32667C3.54444 3.10926 3.80593 3.00037 4.11111 3H11.8889C12.1944 3 12.4561 3.10889 12.6739 3.32667C12.8917 3.54444 13.0004 3.80593 13 4.11111V11.8889C13 12.1944 12.8913 12.4561 12.6739 12.6739C12.4565 12.8917 12.1948 13.0004 11.8889 13H4.11111ZM4.11111 11.8889H11.8889V4.11111H4.11111V11.8889ZM4.66667 10.7778H11.3333L9.25 8L7.58333 10.2222L6.33333 8.55556L4.66667 10.7778Z"
        fill="currentColor"
      />
    </svg>
  );
};
